import { BedIcon } from '@jouzen/ecom-components/icons/BedIcon';
import { HeartIcon } from '@jouzen/ecom-components/icons/HeartIcon';
import { HrvIcon } from '@jouzen/ecom-components/icons/HrvIcon';
import { OvulationOutlineIcon } from '@jouzen/ecom-components/icons/OvulationOutlineIcon';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { SVGIconComponent } from 'types/svgr';

import BillboardStatsModuleMod from '@/app/components/BillboardStatsModuleMod';
import type { AccuracyCardProps } from '@/app/components/LandingPage/LandingPageAccuracy/AccuracyCard';
import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

const accuracyCards: AccuracyCardProps[] = [
  {
    heading: 'hra_heading',
    icon: HeartIcon as SVGIconComponent,
    note: 'science_research_2025_hra_copy',
    percentage: 0.99,
  },
  {
    heading: 'hrv_heading',
    icon: HrvIcon as SVGIconComponent,
    note: 'science_research_2025_hra_copy',
    percentage: 0.98,
  },
  {
    heading: 'science_research_2025_ovulation_stat_heading',
    icon: OvulationOutlineIcon as SVGIconComponent,
    note: 'science_research_2025_ovulation_stat_copy',
    percentage: 0.94,
  },
  {
    heading: 'sta_heading',
    icon: BedIcon as SVGIconComponent,
    note: 'science_research_2025_sta_copy',
    percentage: 0.79,
  },
];

const AccuracySection = () => {
  const t = useTranslations();

  return (
    <BillboardStatsModuleMod
      accuracyCards={accuracyCards}
      content={
        <Motion
          className="relative"
          initial={{ opacity: 0 }}
          transition={{ delay: 0.35, duration: 0.5, type: 'tween' }}
          viewport={{ once: true }}
          whileInView={{ opacity: 1 }}
        >
          <Typography
            className="mb-6 font-bold uppercase lg:my-2 lg:text-sandstone-200"
            color="unset"
            variant="body-large"
          >
            {t('pdp_horizon_breakthrough_sensors_title')}
          </Typography>
          <Typography
            className="mb-4 lg:text-sandstone-200"
            color="unset"
            variant="body-large"
          >
            {t('science_research_2025_sensors_copy')}
          </Typography>
          <ul className="mt-6 list-disc pl-8 lg:text-sandstone-200 [&>li]:my-2">
            <RichText messageKey="science_research_2025_sensors_list" />
          </ul>
        </Motion>
      }
      image={{
        srcSet: [
          {
            media: '(max-width: 1023px)',
            src: 'blue-sky/science-and-research/science-callout-or4-mobile',
          },
          {
            media: '(min-width: 1024px)',
            src: 'blue-sky/science-and-research/science-callout-or4-desktop',
          },
        ],
      }}
    />
  );
};

export default AccuracySection;
